// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.num-destac[data-v-0d9272aa] {\n  font-weight: 600;\n  font-size: 24px;\n}\n.swal2-container[data-v-0d9272aa] {\n  z-index: 9999999 !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
